import { Button, DatePicker, Input, Modal } from "antd";
import moment from "moment";

export default function EditSubscriptionRecord({ props }) {
  return (
    <Modal
      visible={props.editVisible}
      title="Edit Subscription Record"
      onOK={props.editSubscription}
      onCancel={props.toggleEditPopup}
      footer={[
        <Button key="Back" onClick={props.toggleEditPopup}>
          Return
        </Button>,
        <Button
          type="primary"
          key="submit"
          className={"btn btn-success"}
          loading={props.loading}
          onClick={props.editSubscription}
        >
          Submit
        </Button>,
      ]}
    >
      <div className="p-2">
        <span>Subscription ID</span>
        <Input value={props.subscriptionData.id} disabled={true} />
      </div>

      <div className="p-2">
        <span>User Email</span>
        <Input value={props.subscriptionData.user?.email} disabled={true} />
      </div>

      <div className="p-2">
        <span>Accessgroup</span>
        <Input
          value={props.subscriptionData.access_group?.name}
          disabled={true}
        />
      </div>

      <div className="p-2">
        <span>Start Date</span>
        <div>
          <DatePicker
            value={moment(props.startDate)}
            showTime
            onChange={(e) => {
              props.setStartDate(e);
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
